module.exports = __webpack_public_path__ + "img/a97d63f.png";